import { formatDate } from "../util/date-format";

export const getLocationItemData = (propData: any[], t: any): any[] => {
  const data = propData.map((e: any) => [
    e.code,
    e.name,
    e.zipCode,
    e.street,
    e.number,
    e.county,
    e.place,
    e.province,
    e.country,
    e.countryISO3,
    e.latitude,
    e.longitude,
    e.coordinateSystem,
    e.insuredName,
    e.insuredCode,
    formatDate(e.inceptionDate),
    formatDate(e.expirationDate),
    formatDate(e.evaluationDate),
    // e.currency,
    e.perilsCovered,
    e.occupancy ? t("occupancyOptions." + e.occupancy) : e.occupancy,
    e.numberOfRisks,
    e.building,
    e.content,
    e.businessInterruption,
    e.propertyDamage,
    e.limit,
    e.deductible,
    e.other,
    e.total
  ]);

  data.forEach((item: any, index: number) => {
    item.forEach((value: any, i: number) => {
      if (value === null || value === undefined) {
        data[index][i] = "";
        return;
      }
      const strValue = String(value);
      if (strValue.includes("NaN")) {
        data[index][i] = strValue.replace("NaN", "");
        return;
      }
      if (strValue.includes("null")) {
        data[index][i] = strValue.replace("null", "");
        return;
      }
      if (strValue.includes("undefined")) {
        data[index][i] = strValue.replace("undefined", "");
        return;
      }
    });
  });

  return data;
};
